import React, { Suspense }from 'react';
import { render } from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import "assets/scss/material-dashboard-pro-react.scss?v=1.8.0";

import InstitutionalDayLayout from "beaktDay/layouts/Institutional.js";
import AdminDayLayout from "beaktDay/layouts/Admin.js";
import Agenda from 'beaktDay/views/AdminAgenda/Agenda/Agenda';
import AuthClinicLayout from "beaktClinic/layouts/Auth.js";
import AdminClinicLayout from "beaktClinic/layouts/Admin.js";
import AdminMatrizLayout from "beaktMatriz/layouts/Admin.js";
import Admin from "beaktAdmin/layouts/Admin.js";

import './i18n';

const mainAPP = process.env.REACT_APP_MAIN
const history = createBrowserHistory();

const validmainApp = () => {
  //if(mainAPP === "null")
  // <div> <center> <br/> parameter REACT_APP_MAIN is missing on file .ENV </center></div>
};

const Routes = () => {
return (  
    <Router history={history}>
      <Switch>   
          <Route path="/auth" component={AuthClinicLayout} />
          <Route path="/adminclinic" component={AdminClinicLayout} /> 
          <Route path="/profile" component={AdminClinicLayout} />  
          <Route path="/institutionalday" component={InstitutionalDayLayout} />
          <Route path="/adminday" component={AdminDayLayout} />
          <Route path="/externalagenda" component={Agenda} />      
          <Route path="/profile" component={AdminDayLayout} /> 
          <Route path="/adminmatriz" component={AdminMatrizLayout} /> 
          <Route path="/admin" component={Admin} /> 
          {mainAPP === "DAY" && <Redirect from="/" to="/institutionalday/login" />}        
          {mainAPP === "CLINIC" && <Redirect from="/" to="/auth/login" />}  
      </Switch>
    </Router>
  );
};

const App = () => (
  <div>
    <Suspense fallback={null}>
      
      <Routes />
    </Suspense>
  </div>
);

const rootElement = document.getElementById("root");
render(<App />, rootElement);
